import { Serializable } from "../util/Serialization";
import { BaseDynamoClass } from "./BaseDynamoClass";

export class SearchResult<T extends BaseDynamoClass<any>> implements Serializable {
    _className: string = "SearchResult";
    className: string = "SearchResult";
    _deserializeClassName: string = "SearchResult";
    count?: number;
    scannedCount?: number;
    lastEvaluatedKey?: {PK: string, SK: string}
    items: Array<T> = [];

    constructor(count? : (number  ), scannedCount? : (number  ), lastEvaluatedKey? : ({PK: string, SK: string}  )){
        this._className = "SearchResult";
        if(count) this.count = count;
        if(scannedCount) this.scannedCount = scannedCount;
        if(lastEvaluatedKey) this.lastEvaluatedKey = lastEvaluatedKey;
    }
    getIgnoreFields(): string[] {
        return [];
    }
}